import * as m from "~/paraglide/messages.js";
import type { ServicePage } from "./types";

export function getIntegrationPage(): ServicePage {
  return {
    art: {
      fields: [
        {
          term: m.svc_integration_art_field_source(),
          value: m.svc_integration_art_value_source(),
        },
        {
          term: m.svc_integration_art_field_supplier(),
          value: m.svc_integration_art_value_supplier(),
        },
        {
          term: m.svc_integration_art_field_total(),
          value: m.svc_integration_art_value_total(),
        },
        {
          term: m.svc_integration_art_field_due(),
          value: m.svc_integration_art_value_due(),
        },
      ],
      kind: "document-fields",
    },
    artNote: m.svc_integration_art_note(),
    capabilityId: "full-systems",
    cta: {
      lede: m.svc_integration_cta_lede(),
      title: m.svc_integration_cta_title(),
    },
    faq: [
      {
        answer: m.svc_integration_faq_1_answer(),
        question: m.svc_integration_faq_1_question(),
      },
      {
        answer: m.svc_integration_faq_2_answer(),
        question: m.svc_integration_faq_2_question(),
      },
      {
        answer: m.svc_integration_faq_3_answer(),
        question: m.svc_integration_faq_3_question(),
      },
      {
        answer: m.svc_integration_faq_4_answer(),
        question: m.svc_integration_faq_4_question(),
      },
    ],
    intro: m.svc_integration_intro(),
    keywords:
      "AI integration services, AI API integration, LLM integration services, AI document processing, AI data extraction, AI CRM automation, AI consulting, AI integrācija, AI konsultācijas",
    label: m.svc_integration_label(),
    limits: {
      body: m.svc_integration_limits_body(),
      items: [
        {
          term: m.svc_integration_limit_1_term(),
          value: m.svc_integration_limit_1_value(),
        },
        {
          term: m.svc_integration_limit_2_term(),
          value: m.svc_integration_limit_2_value(),
        },
        {
          term: m.svc_integration_limit_3_term(),
          value: m.svc_integration_limit_3_value(),
        },
      ],
      title: m.svc_integration_limits_title(),
    },
    meta: {
      description: m.svc_integration_meta_description(),
      title: m.svc_integration_meta_title(),
    },
    nav: m.svc_integration_nav(),
    scope: {
      body: m.svc_integration_scope_body(),
      points: [
        m.svc_integration_scope_point_1(),
        m.svc_integration_scope_point_2(),
        m.svc_integration_scope_point_3(),
        m.svc_integration_scope_point_4(),
      ],
      title: m.svc_integration_scope_title(),
    },
    serviceType: "AI integration services and LLM integration",
    slug: "ai-integration",
    steps: {
      body: m.svc_integration_steps_body(),
      items: [
        m.svc_integration_step_1(),
        m.svc_integration_step_2(),
        m.svc_integration_step_3(),
        m.svc_integration_step_4(),
      ],
      title: m.svc_integration_steps_title(),
    },
    title: [m.svc_integration_title_1(), m.svc_integration_title_2()],
    uses: [
      {
        term: m.svc_integration_use_1_term(),
        value: m.svc_integration_use_1_value(),
      },
      {
        term: m.svc_integration_use_2_term(),
        value: m.svc_integration_use_2_value(),
      },
      {
        term: m.svc_integration_use_3_term(),
        value: m.svc_integration_use_3_value(),
      },
      {
        term: m.svc_integration_use_4_term(),
        value: m.svc_integration_use_4_value(),
      },
    ],
  };
}
